<opac-dialog
  [open]="open"
  [title]="'general.information' | translate"
  (closed)="cancel.emit()"
>
  <div class="content">
    <p>{{'button.subscription.text1' | translate}}</p>
    <p>{{'button.subscription.text2' | translate}}</p>
  </div>

  <div slot="actions">
    <opac-button (click)="accept.emit()">{{ 'button.subscription' | translate }}</opac-button>
  </div>
</opac-dialog>
